/**
 * User-facing filter chip label for Explore search / bank filters.
 * Rewrites legacy "Floor" prefixes to "Bank"; optionally prefixes Bank for map picks.
 */
export function displayFilterChipLabel(text: string, bankFilter = false): string {
  let label = String(text ?? '').trim();
  if (/^Floor Location\b/i.test(label)) {
    label = label.replace(/^Floor Location/i, 'Bank Location');
  } else if (/^Floor\b/i.test(label)) {
    label = label.replace(/^Floor\b/i, 'Bank');
  }
  if (bankFilter && !/^Bank\b/i.test(label)) {
    return `Bank ${label}`;
  }
  return label;
}
